import React from 'react'
import '../CSS/CurrencyModal.css'


const CurrencyModal = () => {
    return (
        <div className="currencyModal">

        </div>
    )
}

export default CurrencyModal
